import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { ChatExchange } from '../../../models/ai-insights/chat-exchange';
import { ChatSession } from '../../../models/ai-insights/chat-session';

export const sessionEntityAdapter: EntityAdapter<ChatExchange> = createEntityAdapter<ChatExchange>({
  // ISO 8601 format (YYYY-MM-DD) is designed so that alphabetical order matches chronological order.
  // No conversion required.
  // ASCENDING sort, i.e. from oldest to newest date
  sortComparer: (a, b) => a?.question?.timestamp?.localeCompare(b?.question?.timestamp),
});
export const sessionsEntityAdapter: EntityAdapter<ChatSession> = createEntityAdapter<ChatSession>({
  // DESCENDING sort, i.e. from newest to oldest date
  sortComparer: (a, b) => b?.update_time?.localeCompare(a?.update_time),
});